import { api, makeGetQueryFn } from 'shared/api';

import { FetchExternalJobsParams, FetchJobApplicationCountersResponse, FetchJobApplicationsParams, FetchJobApplicationsResponse, JobApplication } from '../types';
import { mapJobStatusToSendingStatuses } from '../utils/statusMapper';

export const queryFetchJobApplications = (params: FetchJobApplicationsParams = {}) =>
    makeGetQueryFn<FetchJobApplicationsResponse>((context) => {
        return api.get<FetchJobApplicationsResponse>(
            `/candidatePortal/assignments`,
            undefined,
            { 
                params,
                ...(context?.signal ? { signal: context.signal } : {}),
                paramsSerializer: { indexes: null }
            }
        );
    });

export const queryFetchJobDetails = (id: string) =>
    makeGetQueryFn<JobApplication>((context) => {
        return api.get<JobApplication>(
            `/candidatePortal/assignments/${ id }`,
            undefined,
            context?.signal ? { signal: context.signal } : {}
        );
    });

export const queryFetchJobCounters = () =>
    makeGetQueryFn<FetchJobApplicationCountersResponse>((context) => {
        return api.get<FetchJobApplicationCountersResponse>(
            '/candidatePortal/assignments/counts',
            undefined,
            context?.signal ? { signal: context.signal } : {}
        );
    });

export const queryFetchExternalJobs = (params: FetchExternalJobsParams) =>
    makeGetQueryFn<FetchJobApplicationsResponse>((context) => {
        return api.get<FetchJobApplicationsResponse>(
            '/candidatePortal/assignments/external',
            undefined,
            {
                params,
                ...(context?.signal ? { signal: context.signal } : {}),
                paramsSerializer: { indexes: null }
            }
        );
    });

export { mapJobStatusToSendingStatuses };
